/* Harris Auto — "garage" vehicle state (sitewide).
   Persists the shopper's selected Year/Make/Model to localStorage and
   broadcasts changes so the header chip, product fitment badge, and
   add-to-cart line items all stay in sync across pages. */
(function () {
  var KEY = "harrisGarage";

  function read() {
    try {
      var g = JSON.parse(localStorage.getItem(KEY) || "null");
      if (g && g.year && g.make && g.model) return g;
    } catch (e) {}
    return null;
  }

  function write(g) {
    try { localStorage.setItem(KEY, JSON.stringify(g)); } catch (e) {}
    window.dispatchEvent(new CustomEvent("harrisgarage:change", { detail: g }));
  }

  function clear() {
    try { localStorage.removeItem(KEY); } catch (e) {}
    window.dispatchEvent(new CustomEvent("harrisgarage:change", { detail: null }));
  }

  function label(g) {
    g = g || read();
    return g ? g.year + " " + g.make + " " + g.model : "";
  }

  /* Merge any ?year=&make=&model= from the URL into storage so a shared
     results link seeds the garage even on first visit. */
  function syncFromUrl() {
    try {
      var p = new URLSearchParams(location.search);
      var y = p.get("year"), mk = p.get("make"), md = p.get("model");
      if (y && mk && md) {
        var g = { year: y, make: mk, model: md };
        var pid = p.get("platform");
        if (pid) g.platform = pid;
        write(g);
        return g;
      }
    } catch (e) {}
    return read();
  }

  window.HarrisGarage = {
    read: read,
    write: write,
    clear: clear,
    label: label,
    syncFromUrl: syncFromUrl,
  };
})();
